import { AUTH, XEERPA_CALLBACK } from "constants/api";
import axios from "axios";
import LoadingScreen from "components/loading-screen";
import { useUTMParams } from "components/utms/useUTMParams";
import useLocalStorage from "hooks/use-local-storage";
import useQuery from "hooks/use-query";
import useRedirect from "hooks/use-redirect";
import useRouter from "hooks/use-router";
import { useEffect, useState } from "react";
import { getAuth, signInWithCustomToken, UserCredential } from "firebase/auth";
import utmServices from "services/utm-services";
import textServices from "services/text-services";
import { createUserProperties, dlSetUserInfo, dlTrackEvent } from "components/dataLayer/dataLayer";
import { useSession } from "contexts/session-context";
import { UserData } from "contexts/session-context/session-reducer";
import { Prize } from 'views/prizes/types'
import CONFIGS from "build/Config";
import { useAgegate } from "hooks/use-agegate";
import ExchangeComponent from "components/exchange";

const validatorsQuery = ['toexternal', 't', 'tointernal']

export default function XeerpaManager() {
  const [isGetParams, setIsGetParams] = useState(false)
  const utmParams = useUTMParams();
  const query = useQuery()
  const firbaseAuth = getAuth();
  const { push } = useRouter()
  const [toExternal, , removeValue] = useLocalStorage<string>('toexternal');
  const [{ user }, { setSession, setUser }] = useSession()
  const [, { redirectByLocal, getRedirectLocal }] = useRedirect();
  const { setAgeLocalForm } = useAgegate();
  const [prize, setPrize] = useState<{ prize: Prize; name: string; buttonText; callback: () => void }>(null)

  const getUrlUtm = (urlBase: string) => {
    const url = new URL(decodeURI(urlBase));

    for (const key in utmParams) {
      if (utmParams[key] && !url?.searchParams.has(key)) {
        url?.searchParams.set(key, utmParams[key]);
      }
    }

    return url
  }

  const redirectToXeerpa = () => {
    let url = getUrlUtm(XEERPA_URL)
    // Implements an A/B Testing based on utm_term, only for DosEquis
    if (false as any || ["dosequis"].includes(THEME)) {
      for (const key in utmParams) {
        if (key === 'utm_term' && utmParams[key] === 'VideoAd_TVCFranquicia_V1') {
          url = getUrlUtm(`${XEERPA_URL}social`);
        }
      }
    }
    window.location.assign(`${url?.toString()}`)
  }

  const completeData = (user: UserData, session: UserCredential) => {
    setSession(session)
    setUser(user)

    dlTrackEvent('login', { method: 'email', section: 'xeerpa :: complete' }, user?.hashId)

    if (toExternal) {
      removeValue()
      const url = getUrlUtm(toExternal)
      return window.location.assign(url?.toString())
    };

    if (getRedirectLocal()) return redirectByLocal();

    const isComplete = (!user?.birthday || (!user?.genre || !user?.genreId))
    if (!CONFIGS?.signUp?.base && isComplete) return push('/information/update?isNew=true');

    return push(`/home`)
  }

  const handleAuth = async () => {
    try {
      const utm = utmServices.utmRead()
      const { data: access } = await axios.post(`${XEERPA_CALLBACK}`, { body: query?.get('t'), utm, referralCode: query?.get('referralCode') }, { headers: { 'Ph-Api-Id': PH_API_ID ?? 1 } });
      const session = await signInWithCustomToken(firbaseAuth, access.firebaseAccessToken);

      const lang = textServices.language
      const accessToken = (session.user as any).accessToken;
      const body: any = { accessToken: access?.providerAccessToken, firstName: access?.displayName, utm, lang }
      const { data: { profile: user } } = await axios.post(AUTH, body, { headers: { Authorization: `Bearer ${accessToken}`, 'Ph-Api-Id': PH_API_ID ?? 1 } })
      gtag('event', 'login', {
        event_label: `Login - Xeerpa`,
        method: `Xeerpa`
      })
      dlTrackEvent('user_interaction', {
        action: `redirect`,
        section: 'xeerpa :: redirect'
      }, user?.hashId)
      dlSetUserInfo(user?.hashId ?? user?.id)
      setAgeLocalForm(new Date(user?.birthday ?? ''))
      createUserProperties(user, 'xeerpa')

      if (access?.prize) {
        return setPrize({
          prize: access?.prize,
          name: user?.firstName,
          buttonText: 'Continuar',
          callback: () => completeData(user, session)
        })
      } else {
        completeData(user, session)
      }
    } catch (err) {
      alert('Ha ocurrido un error al iniciar sesión')
      if (toExternal) window.location.replace(getUrlUtm(toExternal ?? ''))
      else push('/start')
    }
  }

  useEffect(() => {
    if (user) return push('/home');
    if (isGetParams) {
      if (Array.from(query)?.some(([key]) => validatorsQuery?.includes(key))) {
        if (query?.get('t')) handleAuth()
        else redirectToXeerpa()
      } else {
        push('/home')
      }
    }
  }, [isGetParams])

  useEffect(() => {
    setTimeout(() => {
      setIsGetParams(true)
    }, 1000)
  }, [])


  if (prize) {
    return (
      <ExchangeComponent
        buttons={{
          handleMenu: prize?.callback,
          handleButtonCommon: prize?.callback,
          handleButtonSticker: prize?.callback,
          text: prize?.buttonText
        }}
        item={prize?.prize}
        module="login"
        name={prize?.name}
      />
    )
  }

  return <LoadingScreen />
}